import {
  GET_USER_REQ,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  CREATE_USER_REQ,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  GET_USER_DETAIL_REQ,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_ERROR,
  GET_COMPANY_DETAIL_REQ,
  GET_COMPANY_DETAIL_SUCCESS,
  GET_COMPANY_DETAIL_ERROR,
  GET_LOCATION_REQ,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
  GET_CARD_REQ,
  GET_CARD_SUCCESS,
  GET_CARD_ERROR,
  CREATE_LOCATION_REQ,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_ERROR,
  DELETE_LOCATION_REQ,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  UPDATE_LOCATION_REQ,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_ERROR,
  UPDATE_ASSETS_REQ,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_ASSETS_ERROR,
  UPDATE_BUSINESS_INFO_REQ,
  UPDATE_BUSINESS_INFO_SUCCESS,
  UPDATE_BUSINESS_INFO_ERROR,
  UPDATE_PROFILE_INFO_REQ,
  UPDATE_PROFILE_INFO_SUCCESS,
  UPDATE_PROFILE_INFO_ERROR,
  GET_ADDRESS_REQ,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_ERRORS,
  CREATE_ORDER_REQ,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_ERROR,
  ORDER_PRICE_REQ,
  ORDER_PRICE_SUCCESS,
  ORDER_PRICE_ERROR,
  POST_ORDER_ADDRESS_REQ,
  POST_ORDER_ADDRESS_SUCCESS,
  POST_ORDER_ADDRESS_ERROR,
  UPDATE_ORDER_REQ,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_ERROR,
  POST_CHARGES_REQ,
  POST_CHARGES_SUCCESS,
  POST_CHARGES_ERROR,
  POST_CREDIT_CHARGES_REQ,
  POST_CREDIT_CHARGES_SUCCESS,
  POST_CREDIT_CHARGES_ERROR,
  CREATE_TOKEN_REQ,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_ERROR,
} from "../constants";
const initialState = {
  isLoading: false,
  users: [],
  error: null,
  userDetails: {},
  companyDetails: {},
  locations: [],
  cards: [],
  metaData: {},
  addresses: [],
  isLoadingAddress: false,
  orderData: {},
  isCreateOrder: false,
  isOrderPrice: false,
  isPostAddress: false,
  isUpdateOrder: false,
  isPostCharge: false,
  isCardReqLoading: false,
  priceObj:{}
};
export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_REQ: {
      return {
        ...state,
        isLoading: true,
        users: [],
      };
    }
    case GET_USER_SUCCESS: {
      console.log("success==>", action.metaData);
      if (!Array.isArray(action.res) && action.id) {
        const index = state.users.findIndex((item) => item.id === action.id);
        state.users.splice(index, 1, action.res);
        // return { ...state, isLoading: false, error: null, users:state.users };
        return;
      }
      if (!Array.isArray(action.res) && !action.id) {
        state.users.unshift(action.res);

        // return { ...state, isLoading: false, error: null, users:state.users };
        return;
      }
      return {
        ...state,
        isLoading: false,
        error: null,
        users: action.res,
        metaData: action.metaData,
      };
    }

    case GET_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
        users: action.res,
      };
    }
    case CREATE_USER_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_USER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case CREATE_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case GET_USER_DETAIL_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_USER_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        userDetails: action.res,
      };
    }
    case GET_USER_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case GET_COMPANY_DETAIL_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_COMPANY_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        companyDetails: action.res,
      };
    }
    case GET_COMPANY_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case GET_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_LOCATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        locations: action.res,
      };
    }
    case GET_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case GET_CARD_REQ: {
      return {
        ...state,
        isLoading: true,
        cards: [],
      };
    }
    case GET_CARD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        cards: action.res,
      };
    }
    case GET_CARD_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case CREATE_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CREATE_LOCATION_SUCCESS: {
      state.locations.push(action.res);
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case CREATE_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case DELETE_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DELETE_LOCATION_SUCCESS: {
      const findIndex = state.locations.findIndex((v) => v.id === action.res);

      state.locations.splice(findIndex, 1);

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case DELETE_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_LOCATION_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_LOCATION_SUCCESS: {
      const findIndex = state.locations.findIndex((v) => v.id === action.id);
      state.locations.splice(findIndex, 1, action.data);

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_LOCATION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_ASSETS_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_ASSETS_SUCCESS: {
      state.companyDetails = {
        ...state.companyDetails,

        rmx_company_asset: {
          ...state.companyDetails.rmx_company_asset,
          description: action.data.description,
          cover: action.data.cover,
          logo: action.data.logo,
          store_name: action?.data?.store_name,
        },
      };

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_ASSETS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_BUSINESS_INFO_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_BUSINESS_INFO_SUCCESS: {
      state.companyDetails = action?.data;

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_BUSINESS_INFO_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }

    case UPDATE_PROFILE_INFO_REQ: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UPDATE_PROFILE_INFO_SUCCESS: {
      state.userDetails = action?.data;

      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case UPDATE_PROFILE_INFO_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    }
    case GET_ADDRESS_REQ: {
      return {
        ...state,
        isLoadingAddress: true,
      };
    }
    case GET_ADDRESS_SUCCESS: {
      return {
        ...state,
        isLoadingAddress: false,
        error: null,
        addresses: action.data,
      };
    }
    case GET_ADDRESS_ERRORS: {
      return {
        ...state,
        isLoadingAddress: false,
        error: null,
      };
    }

    case CREATE_ORDER_REQ: {
      return {
        ...state,
        isCreateOrder: true,
      };
    }
    case CREATE_ORDER_SUCCESS: {
      return {
        ...state,
        isCreateOrder: false,
        error: null,
        orderData: action.data,
      };
    }
    case CREATE_ORDER_ERROR: {
      return {
        ...state,
        isCreateOrder: false,
        error: null,
      };
    }

    case ORDER_PRICE_REQ: {
      return {
        ...state,
        isOrderPrice: true,
      };
    }
    case ORDER_PRICE_SUCCESS: {
      return {
        ...state,
        isOrderPrice: false,
        priceObj:action.data
      };
    }
    case ORDER_PRICE_ERROR: {
      return {
        ...state,
        isOrderPrice: false,
      };
    }

    case POST_ORDER_ADDRESS_REQ: {
      return {
        ...state,
        isPostAddress: true,
      };
    }
    case POST_ORDER_ADDRESS_SUCCESS: {
      return {
        ...state,
        isPostAddress: false,
      };
    }
    case POST_ORDER_ADDRESS_ERROR: {
      return {
        ...state,
        isPostAddress: false,
      };
    }

    case UPDATE_ORDER_REQ: {
      return {
        ...state,
        isUpdateOrder: true,
      };
    }
    case UPDATE_ORDER_SUCCESS: {
      return {
        ...state,
        isUpdateOrder: false,
      };
    }
    case UPDATE_ORDER_ERROR: {
      return {
        ...state,
        isUpdateOrder: false,
      };
    }

    case POST_CHARGES_REQ: {
      return {
        ...state,
        isPostCharge: true,
      };
    }
    case POST_CHARGES_SUCCESS: {
      return {
        ...state,
        isPostCharge: false,
      };
    }
    case POST_CHARGES_ERROR: {
      return {
        ...state,
        isPostCharge: false,
      };
    }

    case POST_CREDIT_CHARGES_REQ: {
      return {
        ...state,
        isPostCharge: true,
      };
    }
    case POST_CREDIT_CHARGES_SUCCESS: {
      return {
        ...state,
        isPostCharge: false,
      };
    }
    case POST_CREDIT_CHARGES_ERROR: {
      return {
        ...state,
        isPostCharge: false,
      };
    }
    case CREATE_TOKEN_REQ: {
      return {
        ...state,
        isCardReqLoading: true,
      };
    }
    case CREATE_TOKEN_SUCCESS: {
      return {
        ...state,
        isCardReqLoading: false,

      };
    }
    case CREATE_TOKEN_ERROR: {
      return {
        ...state,
        isCardReqLoading: false,
      };
    }
    default: {
      return { ...state };
    }
  }
}
